export enum LoginView {
  Email,
  Password,
  TwoFactor,
}
